import { DOC_HINTS_TYPE_ENUM, HintsType } from "interfaces/tooltipSettings";
import { fetchStatus, withRequestTracking } from "utils/storesUtils";
import { downloadDefaultDocTooltips, ENDPOINTS, getAllTooltips, uploadTooltipsFile } from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { IStores } from "stores";
import { downloadFileBlob } from "utils";

export class HintsManagementStore extends ListStoreConstructor<any> {
  constructor(stores: IStores) {
    super(
      stores,
      async (): Promise<{ content: HintsType[]; size: number; totalPages: number; totalElements: number }> => {
        const res = await getAllTooltips();

        return {
          content: res,
          size: res.length,
          totalPages: 1,
          totalElements: res.length,
        };
      },
      {
        pollingInterval: 0,
      }
    );
  }
}
